import { LIX_ABI } from '@lfg/abis';

import { GALA_SC_ADDRESS, USDC_ABI, USDC_SC_ADDRESS, USDT_ABI, USDT_SC_ADDRESS } from '@/global/configs/common.config';
import { BSC_DECIMAL, GALA_DECIMAL, USDC_DECIMAL, USDT_DECIMAL } from '@/global/configs/decimal.config';
import type { Address } from '@/global/types/common.type';

import { Coin, CoinSymbol } from '../enums/common.enums';
import type { KeyIndex } from '../types/common.type';

export interface TokenConfig {
  decimals: number;
  address: Address | null;
  abi: any;
  key: Coin;
  name: string;
}

export const PaymentName: KeyIndex<string> = {
  [Coin.BSC]: 'BNB',
  [Coin.LIX]: 'LIX [BSC BEP20]',
  [Coin.USDC]: 'USDC [BSC BEP20]',
  [Coin.USDT]: 'USDT [BSC BEP20]',
};

export interface PaymentMethodItem {
  name: string;
  coin: Coin;
}

export const SUPPORT_COINS = [Coin.BSC, Coin.LIX, Coin.USDT, Coin.USDC] as const;

export const PAYMENT_METHODS: PaymentMethodItem[] = [
  {
    name: PaymentName[Coin.BSC] as string,
    coin: Coin.BSC,
  },
  {
    name: PaymentName[Coin.LIX] as string,
    coin: Coin.LIX,
  },
  {
    name: PaymentName[Coin.USDC] as string,
    coin: Coin.USDC,
  },
  {
    name: PaymentName[Coin.USDT] as string,
    coin: Coin.USDT,
  },
];

export const TOKEN_CONFIG: Record<CoinSymbol, TokenConfig> = {
  [CoinSymbol.BSC]: {
    decimals: BSC_DECIMAL,
    address: null,
    abi: null,
    key: Coin.BSC,
    name: 'BSC',
  },
  [CoinSymbol.LIX]: {
    decimals: GALA_DECIMAL,
    address: GALA_SC_ADDRESS,
    abi: LIX_ABI,
    key: Coin.LIX,
    name: 'LIX',
  },
  [CoinSymbol.USDC]: {
    decimals: USDC_DECIMAL,
    address: USDC_SC_ADDRESS,
    abi: USDC_ABI,
    key: Coin.USDC,
    name: 'USDC',
  },
  [CoinSymbol.USDT]: {
    decimals: USDT_DECIMAL,
    address: USDT_SC_ADDRESS,
    abi: USDT_ABI,
    key: Coin.USDT,
    name: 'USDT',
  },
};
